<template>
    <div class="p-3 h-100 m-3 ">
        <b-row class="pb-5">
            <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                <label class="sa-data-label">Struttura</label>
                <b-form-input type="text" name="Struttura" :disabled="true"
                    v-model="jsonData.codiceStruttura"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <label class="sa-data-label">Codice P.R.I</label>
                <b-form-input type="text" name="Id P.R.I" :disabled="true" v-model="jsonData.idPri"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                <label class="sa-data-label" style="display: inline-block; width: 100%;">Conferma ASP</label>
                <span>
                    <template v-if="jsonData.confermaAsp">✅</template>
                    <template v-else>❌</template>
                </span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                <label class="sa-data-label">Data Conferma ASP</label>
                <date-picker :disabled="true" format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"
                    v-model="jsonData.dataOraConfermaAsp"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-data-label">Nome</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.nome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-data-label">Cognome</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.cognome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-data-label">Identificativo</label>
                <b-form-input :disabled="true" class="w-100 text-upper"
                    v-model="jsonData.identificativo"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-data-label">Data Compilazione</label>
                <date-picker :disabled="isConfermata" format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"
                    v-model="jsonData.dataCompilazione"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-data-label">Comune Nascita</label>
                <b-form-input :disabled="true" id="inline-form-custom-select-pref" v-model="jsonData.comune"
                    class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-data-label">Data Nascita</label>
                <date-picker :disabled="true" format="DD-MM-YYYY" value-type="timestamp" type="date"
                    v-model="jsonData.dataNascita"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-data-label">Eta'</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.eta"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-data-label">Sesso</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.sesso"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Residenza</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.residenza"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Domicilio</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.domicilio"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-data-label">Tipo Trattamento</label>
                <b-form-input :disabled="isConfermata" class="w-100 " v-model="jsonData.tipoTrattamento"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-data-label">Provenienza</label>

                <b-form-input :disabled="isConfermata" class="w-100" v-model="jsonData.provenienza"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Diagnosi in Ingresso</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.diagnosiIngresso"
                    rows="2"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Cenni Anamnestici</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.cenniAnamnestici"
                    rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Valutazione Fisiatrica</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.valutazioneFisiatrica"
                    rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Valutazione Neuropsichiatrica</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.valutazioneNeuropsichiatrica"
                    rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Progetto Riabilitativo</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.progettoRiabilitativo"
                    rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Programmi Riabilitativi - Area Riabilitativa</label>
                <b-form-textarea :disabled="isConfermata" v-model="jsonData.programmiRiabilitativi"
                    rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-data-label">Figure Professionali</label>
                <b-row>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox :disabled="isConfermata" switch v-model="jsonData.fisioterapista">
                                        Fisioterapista
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.fisioterapista || isConfermata"
                                        v-model="jsonData.fisioterapistaText" class="form-control"
                                        placeholder="Fisioterapista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox :disabled="isConfermata" switch v-model="jsonData.logopedista">
                                        Logopedista
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.logopedista || isConfermata"
                                        v-model="jsonData.logopedistaText" class="form-control"
                                        placeholder="Logopedista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox :disabled="isConfermata" switch v-model="jsonData.neuro">
                                        Neuropsicomotricista dell'eta' evolutiva
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.neuro || isConfermata"
                                        v-model="jsonData.neuroText" class="form-control"
                                        placeholder="Neuropsicomotricista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch :disabled="isConfermata"
                                        v-model="jsonData.assistenteSociale">
                                        Assistente Sociale
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text"
                                        :disabled="!jsonData.assistenteSociale || isConfermata"
                                        v-model="jsonData.assistenteSocialeText" class="form-control"
                                        placeholder="Assistente sociale"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch :disabled="isConfermata" v-model="jsonData.psicologo">
                                        Psicologo
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.psicologo || isConfermata"
                                        v-model="jsonData.psicologoText" class="form-control"
                                        placeholder="Psicologo"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch :disabled="isConfermata" v-model="jsonData.terapista">
                                        Terapista Occupazionale
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.terapista || isConfermata"
                                        v-model="jsonData.terapistaText" class="form-control"
                                        placeholder="Terapista occupazionale"></b-col>
                            </b-row>
                        </div>
                    </b-col>

                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import NumeratoriMixin from "../../numeratori/mixins/NumeratoriMixin";
export default {
    components: { DatePicker },
    data() {
        return {
            presidio: {},
            jsonData: {
                nome: null,
                cognome: null,
                identificativo: null,
                dataCompilazione: null,
                comune: null,
                dataNascita: null,
                eta: '',
                sesso: '',
                residenza: '',
                domicilio: '',
                tipoTrattamento: null,
                provenienza: null,
                diagnosiIngresso: '',
                cenniAnamnestici: '',
                valutazioneFisiatrica: '',
                valutazioneNeuropsichiatrica: '',
                progettoRiabilitativo: '',
                programmiRiabilitativi: '',
                fisioterapista: false,
                fisioterapistaText: '',
                logopedista: false,
                logopedistaText: '',
                neuro: false,
                neuroText: '',
                idPri: "",
                assistenteSociale: false,
                assistenteSocialeText: '',
                psicologo: false,
                psicologoText: '',
                terapista: false,
                terapistaText: '',
                confermaAsp: false,
                dataOraInizio: null,
                dataOraFine: null
            },
            pathResourceAcc: "/accettazioni",
            pathResource: "/progettoriabilitativoindividuale",
            comuniOptions: [],
            tipoTrattamentoOptions: [],
            provenienzaOptions: []

        }
    },
    computed: {
        isConfermata() {
            return this.jsonData.confermaAsp;
        }
    },
    watch: {
        'jsonData.fisioterapista': function (params) {
            if (!params) {
                this.jsonData.fisioterapistaText = null;
            }
        },
        'jsonData.logopedista': function (params) {
            if (!params) {
                this.jsonData.logopedistaText = null;
            }
        },
        'jsonData.neuro': function (params) {
            if (!params) {
                this.jsonData.neuroText = null;
            }
        }
        ,
        'jsonData.assistenteSociale': function (params) {
            if (!params) {
                this.jsonData.assistenteSocialeText = null;
            }
        },
        'jsonData.psicologo': function (params) {
            if (!params) {
                this.jsonData.psicologoText = null;
            }
        },
        'jsonData.terapista': function (params) {
            if (!params) {
                this.jsonData.terapistaText = null;
            }
        },

    },
    mounted() {
        this.getPresidio();
    },
    methods: {
        init(jsonData) {
            this.jsonData.dataCompilazione = new Date().getTime();
            this.setDatiAnagraficiPri(jsonData);
        },
        setDatiAnagraficiPri(jsonData) {
            let anagrafica = jsonData.accettazioneAnagrafica;
            this.jsonData.idAccettazione = jsonData.id;
            this.jsonData.cognome = anagrafica.cognome;
            this.jsonData.nome = anagrafica.nome;
            this.jsonData.identificativo = anagrafica.identificativo;
            this.jsonData.comune = anagrafica.comuneNascita;
            this.jsonData.dataNascita = anagrafica.dataNascita;
            this.jsonData.sesso = anagrafica.sesso;
            this.jsonData.residenza = anagrafica.indirizzoResidenza + " , " + anagrafica.capResidenza + " , " + anagrafica.comuneResidenza + " , " + anagrafica.provinciaResidenza;
            this.jsonData.domicilio = anagrafica.indirizzoDomicilio + " , " + anagrafica.capDomicilio + " , " + anagrafica.comuneDomicilio + " , " + anagrafica.provinciaDomicilio;
            this.jsonData.eta = this.calcolaEta(anagrafica.dataNascita);
            this.jsonData.codiceStruttura = this.presidio.codiceStruttura;
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },

        setViewPri(pri, jsonData) {
            this.setDatiAnagraficiPri(jsonData);
            this.jsonData = { ...this.jsonData, ...pri };
        },

        calcolaEta(timestampNascita) {
            const oggi = new Date();
            const dataNascita = new Date(timestampNascita);
            let eta = oggi.getFullYear() - dataNascita.getFullYear();
            const mese = oggi.getMonth() - dataNascita.getMonth();
            const giorno = oggi.getDate() - dataNascita.getDate();
            if (mese < 0 || (mese === 0 && giorno < 0)) {
                eta--;
            }
            return eta;
        },

        getJsonData() {

            return this.jsonData;
        }

    }
}
</script>

<style lang="scss" scoped></style>